import { render } from "./g-ecommerce__nav-bar_item.vue?vue&type=template&id=52a58ec6&ts=true"
import script from "./g-ecommerce__nav-bar_item.vue?vue&type=script&lang=tsx"
export * from "./g-ecommerce__nav-bar_item.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__